import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Render CMS content (markdown-formatted string) as inline formatted HTML.
 * Preserves visual styling of the surrounding container (font, size, color).
 *
 * Usage:
 *   <p className="text-lg">
 *     <PageContent value={mission} />
 *   </p>
 */
export default function PageContent({ value, className = "" }) {
  return (
    <span className={`page-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Inline: unwrap <p> so the parent tag's styles apply
          p: ({ node, ...props }) => <span {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-foreground" {...props} />,
          em: ({ node, ...props }) => <em className="italic" {...props} />,
          a: ({ node, ...props }) => <a className="text-primary hover:underline underline-offset-2 font-medium" target="_blank" rel="noreferrer" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mt-2 space-y-1 inline-block text-left" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mt-2 space-y-1 inline-block text-left" {...props} />,
          li: ({ node, ...props }) => <li {...props} />,
          h1: ({ node, ...props }) => <span className="font-display font-bold text-xl block" {...props} />,
          h2: ({ node, ...props }) => <span className="font-display font-bold text-lg block" {...props} />,
          h3: ({ node, ...props }) => <span className="font-display font-semibold text-base block" {...props} />,
          br: () => <br />,
        }}
      >
        {value || ""}
      </ReactMarkdown>
    </span>
  );
}
